import { useSelector } from 'react-redux'
import { useTimelineContext } from 'context/TimelineContext'
import { editorSelectors } from 'store/features/editor/selectors'
import { useSubscribeToEvent, EVENT_TYPES } from 'services/event-bus'
import { useEffect, useState } from 'react'

const useGetCurrentPlayheadTime = () => {
  const { getCurrentTimeImmediate, isPlaying } = useTimelineContext()
  const isAnyBuffering = useSelector(editorSelectors.isAnyBuffering)

  const [currentTime, setCurrentTime] = useState(getCurrentTimeImmediate())

  // Sync with playHead time on every play/pause
  useEffect(() => {
    setCurrentTime(getCurrentTimeImmediate())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlaying, isAnyBuffering])

  useSubscribeToEvent(EVENT_TYPES.PLAYBACK_TIME_CHANGE, time => {
    if (isNaN(time)) return
    setCurrentTime(time)
  })

  return currentTime
}

export default useGetCurrentPlayheadTime
